import { getComponentFromName } from '@folklore/utils';

import { useBrand, useDefaultBrand } from '../../contexts/SiteContext';
import * as HomeComponents from './homes';

type HomePageProps = {
    brand?: string | null;
    [key: string]: unknown;
};

function HomePage({ brand: brandSlug = null, ...props }: HomePageProps) {
    const hasBrand = brandSlug !== null;
    const { handle: defaultBrandHandle = 'urbania' } = useDefaultBrand();
    const brand = useBrand(brandSlug, !hasBrand ? defaultBrandHandle : null);
    const { handle: brandHandle = null } = brand || {};
    const HomeComponent = getComponentFromName(HomeComponents, brandHandle, 'default');
    return <HomeComponent brand={brand} {...props} />;
}

export default HomePage;
